import { PlaneBufferGeometry, Vector2 } from "three";
import * as THREE from "three";
import { MonsterStatus } from './gameMain';
enum MonsterAnimStatus {
    IDLE,
    SENSOR,
    ACTION,
    HIT
}

export class Monster extends THREE.Object3D {
    public OnSound!: (val: string) => void;
    private geometry!: PlaneBufferGeometry;
    public mesh!: THREE.Mesh;

    private colliderGeometry!: THREE.CircleGeometry;
    private colliderMaterial!: THREE.MeshBasicMaterial;
    private colliderCircle!: THREE.Mesh;

    private hasSensor: boolean = false;
    private sensorGeometry!: THREE.CircleGeometry;
    private sensorMaterial!: THREE.MeshBasicMaterial;
    private sensorCircle!: THREE.Mesh;
    public isDetected: boolean = false;
    public isDebug: boolean = false;
    public sensorIntervalInx: number = 0;

    public status: MonsterStatus = MonsterStatus.NONE;
    public prevStatus: MonsterStatus = MonsterStatus.NONE;
    public targetPosition!: THREE.Vector2;
    public colliderSize: number = 0;
    public offset: THREE.Vector2 = new THREE.Vector2();
    private material!: THREE.MeshBasicMaterial;
    private atlasSize: number = 0;
    public atlasIndexes!: number[][];
    private atlasIntervalIdx = 0;
    private atlasAnimationIdx = 0;
    private atlasAnimationStatus: MonsterAnimStatus = MonsterAnimStatus.IDLE;
    public isEnabled: boolean = true;
    public isLeft: boolean = true;
    constructor(public targetWidth: number, public targetHeight: number, public sensorSize: number = 0) {
        super();
    }
    public randomIntFromInterval(min: number, max: number) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    public SetRenderOrder(order: number) {
        this.mesh!.renderOrder = order;
    }
    public InitTexture(material: THREE.MeshBasicMaterial, atlasSize: number, atlasIndexes: number[][], sizeMultiplier: number = 1.0) {
        this.atlasIndexes = atlasIndexes;
        this.material = material.clone() as THREE.MeshBasicMaterial;
        this.geometry = new THREE.PlaneBufferGeometry(this.targetWidth, this.targetHeight);
        this.mesh = new THREE.Mesh(this.geometry, this.material);
        this.mesh.renderOrder = 0;
        this.mesh.scale.set(sizeMultiplier, sizeMultiplier, sizeMultiplier);
        this.atlasSize = atlasSize;
        this.material.map?.repeat.set(1 / atlasSize, 1 / atlasSize);
        //this.UpdateAtlas(MonsterAnimStatus.IDLE);
        this.add(this.mesh);
        this.mesh.onBeforeRender = () => {
            this.material.map?.offset.set(this.offset.x, this.offset.y);
        };
    }
    public animationTime = 500;
    public UpdateAtlas(atlasIndex: MonsterAnimStatus) {
        this.atlasAnimationStatus = atlasIndex;
        this.atlasAnimationIdx = 0;
        clearInterval(this.atlasIntervalIdx);

        this.SetAtlas(this.atlasIndexes[this.atlasAnimationStatus][(this.atlasAnimationIdx) % this.atlasIndexes[this.atlasAnimationStatus].length]);
        this.atlasIntervalIdx = setInterval(() => {
            this.SetAtlas(this.atlasIndexes[this.atlasAnimationStatus][(++this.atlasAnimationIdx) % this.atlasIndexes[this.atlasAnimationStatus].length]);
        }, this.animationTime);
    }
    public SetAtlas(index: number) {
        this.offset.x = index % this.atlasSize * 1 / this.atlasSize;
        this.offset.y = Math.floor(index / this.atlasSize) * 1 / this.atlasSize;
    }
    public SetDirection(isLeft: boolean) {
        this.isLeft = isLeft;
        this.mesh.scale.setX(Math.abs(this.mesh.scale.x) * (this.isLeft ? -1 : 1));
    }
    public SetStatus(newStatus: MonsterStatus) {
        this.prevStatus = this.status;
        this.status = newStatus


        switch (this.status) {
            case MonsterStatus.DETECT:
                //this.isDetected = true;
                //this.HitTrigger();
                break;
        }
    }

    public SetSensor(size: number) {
        this.hasSensor = true;
        if (this.isDebug) {
            this.sensorGeometry = new THREE.CircleGeometry(size, 32);
            this.sensorMaterial = new THREE.MeshBasicMaterial({ color: 0x666666 });
            this.sensorCircle = new THREE.Mesh(this.sensorGeometry, this.sensorMaterial);
            this.sensorMaterial.transparent = true;
            this.sensorMaterial.opacity = 0.5;
            this.sensorMaterial.needsUpdate = true;
            this.sensorCircle.renderOrder = -2;
            this.add(this.sensorCircle);
        }
    }

    public SetCollider(size: number = this.targetWidth) {
        this.colliderSize = size * 0.5;
        if (this.isDebug) {
            if (this.colliderCircle) {
                this.colliderCircle.scale.set(size, size, size);
            } else {
                this.colliderGeometry = new THREE.CircleGeometry(0.5, 32);
                this.colliderMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff });
                this.colliderCircle = new THREE.Mesh(this.colliderGeometry, this.colliderMaterial);
                this.colliderMaterial.transparent = true;
                this.colliderMaterial.opacity = 0.5;
                this.colliderMaterial.needsUpdate = true;
                this.colliderCircle.renderOrder = -1;
                this.colliderCircle.scale.set(size, size, size);
                this.add(this.colliderCircle);
            }
        }
    }

    public HitTest(points: THREE.Vector2[]) {
        if (this.isDetected || !this.hasSensor || !this.isEnabled) return false;

        for (let i = 0; i < points.length; i++) {
            if (this.sensorSize > points[i].distanceTo(new Vector2(this.position.x, this.position.y))) {
                this.sensorMaterial?.color.setHex(0xff0000);
                //this.SetStatus(MonsterStatus.DETECT);
                this.HitTrigger();
                return true;
            }
        }
        this.sensorMaterial?.color.setHex(0xffffff);
        return false;
    }

    public HitTrigger() {
        this.isDetected = true;
    }

    public Dispose() {
        clearInterval(this.atlasIntervalIdx);
        this.geometry?.dispose();
        this.mesh.geometry?.dispose();

        this.colliderGeometry?.dispose();
        this.colliderMaterial?.dispose();
        if (this.hasSensor) {
            this.sensorGeometry?.dispose();
            this.sensorMaterial?.dispose();
        }

        this.remove(this.mesh);
    }

    public AddYOffset(val: number) {
        this.position.setY(this.position.y - val);
    }

    private radians_to_degrees(radians: number) {
        var pi = Math.PI;
        return radians * (180 / pi);
    }

    public getAngle(p1: THREE.Vector2, p2: THREE.Vector2): number {
        const dx = p2.x - p1.x;
        const dy = p2.y - p1.y;
        const theta = Math.atan2(dy, dx);
        let angle = this.radians_to_degrees(theta);
        if (angle < 0) {
            angle = 360 + angle;
        }
        return theta;
    }
}
export class Cat extends Monster {
    public callBack!: () => THREE.Vector2;
    constructor(targetWidth: number = 3.8, targetHeight: number = 3.8, sensorSize: number = 6) {
        super(targetWidth, targetHeight, sensorSize);
    }

    public init(sx: number, sy: number) {
        this.position.setX(sx + 0.5);
        this.position.setY(sy);

        this.SetCollider();
        this.SetSensor(this.sensorSize);
        this.SetStatus(MonsterStatus.INIT);
    }
    public AddYOffset(val: number) {
        super.AddYOffset(val);
        if (this.status == MonsterStatus.ACTION) {
            this.position.sub(this.dir);
        }
    }
    private intervalIdx: number = 0;
    public SetStatus(newStatus: MonsterStatus) {
        super.SetStatus(newStatus);
        clearInterval(this.intervalIdx);
        switch (this.status) {
            case MonsterStatus.INIT:
                super.UpdateAtlas(MonsterAnimStatus.IDLE);
                //this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.DETECT); }, 1300);
                break;
            case MonsterStatus.DETECT:
                //start timer for preAction

                super.UpdateAtlas(MonsterAnimStatus.SENSOR);
                this.targetPosition = this.callBack();
                this.SetGuide(this.targetPosition);
                this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.ACTION); }, 1000);
                break;
            case MonsterStatus.PREACTION:
                this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.ACTION); }, 500);
                break;
            case MonsterStatus.ACTION:
                //move
                this.animationTime = 100;
                super.UpdateAtlas(MonsterAnimStatus.ACTION);
                break;
            case MonsterStatus.HIT:
                //hit
                this.animationTime = 500;
                super.UpdateAtlas(MonsterAnimStatus.HIT);
                clearInterval(this.intervalIdx);
                break;
        }
    }
    public Dispose() {
        clearInterval(this.intervalIdx);
        super.Dispose();
    }
    public HitTrigger() {
        if (this.status == MonsterStatus.HIT) return;
        this.OnSound("cat_" + this.randomIntFromInterval(1, 3));
        super.HitTrigger();
        this.SetStatus(MonsterStatus.DETECT);
    }
    private dir: THREE.Vector3 = new THREE.Vector3();
    public SetGuide(target: THREE.Vector2 = new THREE.Vector2()) {
        this.callBack = () => { return new THREE.Vector2() };
        this.dir.subVectors(this.position, new THREE.Vector3(target.x, target.y, 0)).normalize();
        this.dir = this.dir.multiplyScalar(0.1);
        super.SetDirection((this.dir.x < 0));
    }
}
export class Bird extends Monster {
    constructor(targetWidth: number = 4, targetHeight: number = 4, sensorSize: number = 4) {
        super(targetWidth, targetHeight, sensorSize);
    }

    public init(sx: number, sy: number, dx: number, dy: number) {
        this.position.setX(sx + 0.5);
        this.position.setY(sy);

        this.SetCollider();
        this.SetSensor(this.sensorSize);
        this.targetPosition = new Vector2(dx, dy);
        this.SetStatus(MonsterStatus.PREACTION);
    }
    public AddYOffset(val: number) {
        //
        if (this.status == MonsterStatus.ACTION) {
            this.position.sub(this.dir);
        }
        if (this.status == MonsterStatus.HIT) {
            super.AddYOffset(val);
        }
    }
    private intervalIdx: number = 0;
    public SetStatus(newStatus: MonsterStatus) {
        super.SetStatus(newStatus);
        clearInterval(this.intervalIdx);
        clearInterval(this.sensorIntervalInx);
        switch (this.status) {
            case MonsterStatus.PREACTION:
                //pre action, show guide
                this.OnSound("bird_" + this.randomIntFromInterval(1, 3));
                super.UpdateAtlas(MonsterAnimStatus.IDLE);
                this.SetGuide(this.targetPosition);
                this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.ACTION); }, 1000);
                break;
            case MonsterStatus.ACTION:
                //move
                break;
            case MonsterStatus.HIT:
                //hit
                super.UpdateAtlas(MonsterAnimStatus.HIT);
                clearInterval(this.intervalIdx);
                break;
        }
    }
    public Dispose() {
        clearInterval(this.intervalIdx);
        super.Dispose();
    }
    public HitTrigger() {
        if (this.status == MonsterStatus.HIT) return;
        super.HitTrigger();
        super.UpdateAtlas(MonsterAnimStatus.SENSOR);

        this.sensorIntervalInx = setInterval(() => {
            this.isDetected = false;
            clearInterval(this.sensorIntervalInx);
            super.UpdateAtlas(MonsterAnimStatus.IDLE);
        }, 500);
    }
    private dir: THREE.Vector3 = new THREE.Vector3();
    public SetGuide(target: THREE.Vector2 = new THREE.Vector2()) {
        this.dir.subVectors(this.position, new THREE.Vector3(target.x, target.y, 0)).normalize();
        this.dir = this.dir.multiplyScalar(0.1);
        super.SetDirection((this.dir.x > 0));
    }
}
export class Cow extends Monster {
    constructor(targetWidth: number = 5.2, targetHeight: number = 5.2, sensorSize: number = 3.7) {
        super(targetWidth, targetHeight, sensorSize);
    }

    public init(sx: number, sy: number) {
        this.position.setX(sx + 0.5);
        this.position.setY(sy);

        this.SetCollider();
        this.SetSensor(this.sensorSize);
        this.SetStatus(MonsterStatus.INIT);
    }
    public SetStatus(newStatus: MonsterStatus) {
        super.SetStatus(newStatus);
        clearInterval(this.sensorIntervalInx);
        switch (newStatus) {
            case MonsterStatus.INIT:
                super.UpdateAtlas(MonsterAnimStatus.IDLE);
                break;
            case MonsterStatus.HIT:
                clearInterval(this.sensorIntervalInx);
                this.isDetected = false;
                super.UpdateAtlas(MonsterAnimStatus.HIT);
                break;
        }
    }
    public HitTrigger() {
        if (this.status == MonsterStatus.HIT) return;
        this.OnSound("cow_" + this.randomIntFromInterval(1, 3));
        super.HitTrigger();
        super.UpdateAtlas(MonsterAnimStatus.SENSOR);

        this.sensorIntervalInx = setInterval(() => {
            clearInterval(this.sensorIntervalInx);
            this.isDetected = false;
            super.UpdateAtlas(MonsterAnimStatus.IDLE);
        }, 500);
    }
    public AddYOffset(val: number) {
        super.AddYOffset(val);
    }
}
export class Human extends Monster {
    public OnBubbleShow!: () => void;
    constructor(targetWidth: number = 5.6, targetHeight: number = 5.6, sensorSize: number = 4.2) {
        super(targetWidth, targetHeight, sensorSize);
    }

    public init(sx: number, sy: number) {
        this.position.setX(sx + 0.5);
        this.position.setY(sy);

        this.SetCollider();
        this.SetSensor(this.sensorSize);
        this.SetStatus(MonsterStatus.INIT);
    }
    public SetStatus(newStatus: MonsterStatus) {
        super.SetStatus(newStatus);
        clearInterval(this.sensorIntervalInx);
        switch (this.status) {
            case MonsterStatus.INIT:
                super.UpdateAtlas(MonsterAnimStatus.IDLE);
                setTimeout(() => { if (this.OnBubbleShow) this.OnBubbleShow(); }, 4000 + this.randomIntFromInterval(-1000, 1000));
                break;
            case MonsterStatus.HIT:
                super.UpdateAtlas(MonsterAnimStatus.HIT);

                break;
        }
    }
    public HitTrigger() {
        this.OnSound("human_" + this.randomIntFromInterval(1, 3));
        super.HitTrigger();
        super.UpdateAtlas(MonsterAnimStatus.HIT);
        this.sensorIntervalInx = setInterval(() => {
            clearInterval(this.sensorIntervalInx);
            this.isDetected = false;
            super.UpdateAtlas(MonsterAnimStatus.IDLE);
        }, 500);
    }
    public AddYOffset(val: number) {
        super.AddYOffset(val);
    }
}
export class Frog extends Monster {
    constructor(targetWidth: number = 3, targetHeight: number = 3, sensorSize: number = 3) {
        super(targetWidth, targetHeight, sensorSize);
    }

    public init(sx: number, sy: number) {
        this.position.setX(sx + 0.5);
        this.position.setY(sy);

        this.SetCollider();
        this.SetSensor(this.sensorSize);
        this.SetStatus(MonsterStatus.INIT);
    }
    private dir: THREE.Vector3 = new THREE.Vector3();
    public SetGuide() {
        this.dir.subVectors(this.position, new THREE.Vector3(this.randomIntFromInterval(-9, 9), this.randomIntFromInterval(-16, 16), 0)).normalize();
        this.dir = this.dir.multiplyScalar(0.1);
        super.SetDirection((this.dir.x < 0));
    }
    public AddYOffset(val: number) {
        super.AddYOffset(val);
        if (this.status == MonsterStatus.ACTION) {
            this.position.sub(this.dir);
        }
    }
    private intervalIdx: number = 0;
    public SetStatus(newStatus: MonsterStatus) {
        super.SetStatus(newStatus);
        clearInterval(this.intervalIdx);
        clearInterval(this.sensorIntervalInx);
        switch (this.status) {
            case MonsterStatus.INIT:
                this.isEnabled = true;
                super.UpdateAtlas(MonsterAnimStatus.IDLE);
                this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.PREACTION); }, 1500);
                break;
            case MonsterStatus.PREACTION:
                this.SetGuide();
                this.isEnabled = true;
                super.UpdateAtlas(MonsterAnimStatus.IDLE);
                this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.ACTION); }, 1000);
                break;
            case MonsterStatus.ACTION:
                //this.SetCollider(this.sizes[this.intervalCount]);
                super.UpdateAtlas(MonsterAnimStatus.ACTION);
                this.isEnabled = false;
                this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.PREACTION); }, 1000);
                break;
            case MonsterStatus.HIT:
                super.UpdateAtlas(MonsterAnimStatus.HIT);
                clearInterval(this.intervalIdx);
                break;
        }
    }
    public HitTrigger() {
        if (this.status == MonsterStatus.HIT) return;
        this.OnSound("frog_" + this.randomIntFromInterval(1, 3));
        super.HitTrigger();
        super.UpdateAtlas(MonsterAnimStatus.SENSOR);

        this.sensorIntervalInx = setInterval(() => {
            clearInterval(this.sensorIntervalInx);
            if (this.status == MonsterStatus.ACTION) {
                super.UpdateAtlas(MonsterAnimStatus.ACTION);
            } else if (this.status == MonsterStatus.HIT) {
                super.UpdateAtlas(MonsterAnimStatus.HIT);
            } else {
                super.UpdateAtlas(MonsterAnimStatus.IDLE);
            }
        }, 500);
    }
    public Dispose() {
        clearInterval(this.intervalIdx);
        super.Dispose();
    }
}
export class Tree extends Monster {
    constructor(targetWidth: number = 2.7, targetHeight: number = 2.7, sensorSize: number = 7.2) {
        super(targetWidth, targetHeight, sensorSize);
    }

    public init(sx: number, sy: number) {
        this.position.setX(sx + 0.5);
        this.position.setY(sy);

        this.SetCollider();

        this.SetStatus(MonsterStatus.INIT);
    }
    public AddYOffset(val: number) {
        super.AddYOffset(val);
    }
    private intervalIdx: number = 0;
    private intervalCount: number = 0;
    public SetStatus(newStatus: MonsterStatus) {
        super.SetStatus(newStatus);
        clearInterval(this.intervalIdx);
        clearInterval(this.sensorIntervalInx);

        switch (this.status) {
            case MonsterStatus.INIT:
                this.isEnabled = false;
                this.intervalCount = 0;
                this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.ACTION); }, 1500);
                super.SetAtlas(this.atlasIndexes[MonsterAnimStatus.IDLE][this.intervalCount]);
                break;
            case MonsterStatus.ACTION:
                this.intervalCount++;
                super.SetAtlas(this.atlasIndexes[MonsterAnimStatus.IDLE][this.intervalCount]);
                if (this.intervalCount < 3) {
                    this.intervalIdx = setInterval(() => { this.SetStatus(MonsterStatus.ACTION); }, 300);
                } else {
                    this.SetCollider(8);
                    this.SetSensor(this.sensorSize);
                    this.isEnabled = true;
                }
                break;
            case MonsterStatus.HIT:
                super.UpdateAtlas(MonsterAnimStatus.HIT);
                break;
        }
    }
    public HitTrigger() {
        if (this.status == MonsterStatus.HIT) return;
        if (this.randomIntFromInterval(0, 1) == 0) {
            this.OnSound("flower_" + this.randomIntFromInterval(1, 3));
        } else {
            this.OnSound("tree_" + this.randomIntFromInterval(1, 3));
        }
        super.HitTrigger();
        super.SetAtlas(this.atlasIndexes[MonsterAnimStatus.SENSOR][0]);

        this.sensorIntervalInx = setInterval(() => {
            clearInterval(this.sensorIntervalInx);
            this.isDetected = false;
            if (this.status == MonsterStatus.HIT) {
                super.UpdateAtlas(MonsterAnimStatus.HIT);
            } else {
                super.SetAtlas(this.atlasIndexes[MonsterAnimStatus.IDLE][this.intervalCount]);
            }
        }, 500);
    }
    public Dispose() {
        clearInterval(this.intervalIdx);
        clearInterval(this.sensorIntervalInx);
        super.Dispose();
    }
}

export class Item extends Monster {
    public OnBubbleShow!: () => void;
    private intervalIdx: number = 0;
    public itemType: number = 0;
    private time: number = 0;
    constructor(targetWidth: number = 2.6, targetHeight: number = 2.6, sensorSize: number = 2) {
        super(targetWidth, targetHeight, sensorSize);
    }

    public init(type: number, time: number) {
        this.itemType = type;
        this.time = time;
        this.position.setX(0.5);
        this.position.setY(0);

        this.mesh.position.setX(this.randomIntFromInterval(3, 5));
        this.mesh.position.setY(this.randomIntFromInterval(3, 7));

        this.SetCollider();
        this.SetSensor(this.sensorSize);
        this.SetStatus(MonsterStatus.INIT);
    }
    public SetStatus(newStatus: MonsterStatus) {
        super.SetStatus(newStatus);
        clearInterval(this.sensorIntervalInx);
        switch (this.status) {
            case MonsterStatus.INIT:
                super.UpdateAtlas(MonsterAnimStatus.IDLE);
                this.intervalIdx = setTimeout(() => { this.Dispose(); }, this.time * 1000);
                break;
            case MonsterStatus.HIT:
                super.UpdateAtlas(MonsterAnimStatus.HIT);

                break;
        }
    }
    public HitTrigger() {
        super.HitTrigger();
        super.UpdateAtlas(MonsterAnimStatus.HIT);
        this.sensorIntervalInx = setInterval(() => {
            clearInterval(this.sensorIntervalInx);
            this.isDetected = false;
            super.UpdateAtlas(MonsterAnimStatus.IDLE);
        }, 500);
    }
    public AddYOffset(val: number) {
        //super.AddYOffset(val);
        this.rotation.z += 0.03;
        this.mesh.rotation.z -= 0.03;
    }
    public Dispose() {
        clearInterval(this.intervalIdx);
        super.Dispose();
    }
}